/**
 * Returns the input value unchanged.
 * @util
 *
 * @template TIn - The type of the input value
 * @template TOut - The type of the output value
 * @param value - The value to return
 * @returns The input value unchanged
 * @__NO_SIDE_EFFECTS__
 */
export function identity(value) {
    return value;
}
//# sourceMappingURL=identity.js.map